import shopNames from "../symbols/getShopNames";
import { HttpRequestGet } from "../../service";
const shopNamesAction = () => ({
  type: shopNames.GET_SHOP_NAMES,
});
const shopNamesSuccessAction = (data: any) => ({
  type: shopNames.GET_SHOP_NAMES_SUCCESS,
  payload: data,
});
const shopNamesFailureAction = (data: any) => ({
  type: shopNames.GET_SHOP_NAMES_FAILURE,
  payload: data,
});
const clearShopNamesAction = () => ({
  type: shopNames.CLEAR_GET_SHOP_NAMES,
});

export function getshopNames(callback?:(resp?:any)=>void) {
  return (dispatch: any) => {
    dispatch(shopNamesAction());
    HttpRequestGet(
      "/admin/v2/shop",
      dispatch,
      shopNamesSuccessAction,
      shopNamesFailureAction,
      true,
      callback
    );
  };
}

export function clearshopNames() {
  return (dispatch: any) => {
    dispatch(clearShopNamesAction());
  };
}
